import { memo } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { NAV_ITEMS, ROUTES, useLocalePath } from "@/navigations";

import styles from "./styles.module.css";

export const Footer = memo(() => {
  const { t } = useTranslation("components");
  const lp = useLocalePath();
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div>
          <p className={styles.brand}>AquaWorks</p>
          <p className={styles.tagline}>{t("footer.tagline")}</p>
          <p className={styles.description}>{t("footer.description")}</p>
        </div>
        <div>
          <p className={styles.heading}>{t("footer.quickLinks")}</p>
          <ul className={styles.links}>
            {NAV_ITEMS.filter((item) => item.path !== ROUTES.HOME).map((item) => (
              <li key={item.path}>
                <Link to={lp(item.path)}>{t(item.labelKey)}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <p className={styles.copyright}>{t("footer.copyright", { year })}</p>
    </footer>
  );
});

Footer.displayName = "Footer";
export default Footer;
